import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scan3dStylingTranslations() {
  return {
    renderingMode: {
      text: $localize`:@@scan3dStyling.renderingMode:Rendering Mode`,
      desc: 'Label for the rendering mode drop down.',
      rgb: {
        text: $localize`:@@scan3dStyling.renderingMode.rgb:RGB`,
        desc: 'Label for the RGB rendering mode.',
        limit: 30,
      },
      classification: {
        text: $localize`:@@scan3dStyling.renderingMode.classification:Classification`,
        desc: 'Label for the classification rendering mode.',
        limit: 30,
      },
      clearance: {
        text: $localize`:@@scan3dStyling.renderingMode.clearance:Clearance`,
        desc: 'Label for the clearance rendering mode.',
      },
      elevation: {
        text: $localize`:@@scan3dStyling.renderingMode.elevation:Elevation`,
        desc: 'Label for the elevation rendering mode.',
        limit: 30,
      },
    },
    eyeDomeLighting: {
      text: $localize`:@@scan3dStyling.eyeDomeLighting:Eye dome lighting`,
      desc:
        'Label for the eye dome lighting switch.' +
        'Eye-Dome Lighting (EDL) is a non-photorealistic, ' +
        'image-based shading technique designed to improve depth ' +
        'perception in scientific visualization images',
      limit: 30,

      radius: {
        text: $localize`:@@scan3dStyling.eyeDomeLighting.radius:EDL Radius`,
        desc: 'Label for eye dome lighting radius setting.',
        limit: 30,
      },
      strength: {
        text: $localize`:@@scan3dStyling.eyeDomeLighting.strength:EDL Strength`,
        desc: 'Label for eye dome lighting strength setting.',
        limit: 30,
      },
    },
    pointSize: {
      text: $localize`:@@scan3dStyling.pointSize:Point Size`,
      desc: 'Label for the point size slider or setting.',
      limit: 30,
    },
    stationIconCullingDistance: {
      text: $localize`:@@scan3dStyling.stationIconCullingDistance:Station Culling`,
      desc:
        'Label for the slider that controls the maximum distance (in meters) ' +
        'between the camera and a station for its icon to remain visible.',
      limit: 30,
    },
    minStationIconsPerScan: {
      text: $localize`:@@scan3dStyling.minStationIconsPerScan:Station Minimum`,
      desc:
        'Label for the slider that controls the minimum number of closest ' +
        'station icons that always remain visible per scan, regardless of ' +
        'the culling distance.',
      limit: 30,
    },
    experimental: {
      text: $localize`:@@scan3dStyling.experimental:Experimental`,
      desc: 'Header for experimental 3d style settings.',
    },
    pointBudget: {
      text: $localize`:@@scan3dStyling.pointBudget:Point Budget`,
      desc: 'Label for the current point budget setting.',
      limit: 30,
    },
    pointDensity: {
      text: $localize`:@@scan3dStyling.pointDensity:Point Density`,
      desc: 'Label for the current point density setting.',
      limit: 30,
    },
    pointShape: {
      text: $localize`:@@scan3dStyling.pointShape:Point Shape`,
      desc: 'Label for the current point shape setting.',
      limit: 30,

      type: {
        paraboloid: {
          text: $localize`:@@scan3dStyling.pointShape.paraboloid:Paraboloid`,
          desc: 'Paraboloid point shape.',
        },
        square: {
          text: $localize`:@@scan3dStyling.pointShape.square:Square`,
          desc: 'Square point shape.',
        },
        circle: {
          text: $localize`:@@scan3dStyling.pointShape.circle:Circle`,
          desc: 'Circle point shape.',
        },
      },
    },
    sizeAttenuation: {
      text: $localize`:@@scan3dStyling.sizeAttenuation:Size Attenuation`,
      desc:
        'Label for size attenuation setting.' +
        'Size attenuation makes points smaller when ' +
        'they are further away from the camera.',
      limit: 30,

      type: {
        on: {
          text: $localize`:@@scan3dStyling.sizeAttenuation.on:On`,
          desc: 'On text for size attenuation.',
        },
        off: {
          text: $localize`:@@scan3dStyling.sizeAttenuation.off:Off`,
          desc: 'Off text for size attenuation.',
        },
      },
    },
  } satisfies TranslationMap;
}
